import { render, staticRenderFns } from "./input-row.vue?vue&type=template&id=2023bd1e&scoped=true&"
import script from "./input-row.vue?vue&type=script&lang=js&"
export * from "./input-row.vue?vue&type=script&lang=js&"
import style0 from "./input-row.vue?vue&type=style&index=0&id=2023bd1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023bd1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VFlex,VIcon,VLayout})
